// extracted by css-extract-rspack-plugin
export default {"mobileNavCollapsed":"_3428268","sideBar":"_d4412174","sideBarWidth":"_1b0c5812","sideBarWidthCollapsed":"_2d20d4dd","sideShadow":"_ff382ec3"};